import { render, staticRenderFns } from "./SeasonCreate.vue?vue&type=template&id=296aab1c"
import script from "./SeasonCreate.vue?vue&type=script&lang=ts"
export * from "./SeasonCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports